export default __webpack_public_path__ + "static/pledge-badge-bbbfb01e9c74bf267109d59dbbf6f754.webp";